export interface OffMarket {
  isOffMarket: boolean;
  isEnabled: boolean;
}

export enum SubTabsFilterOptions {
  All = 'All',
  SpacesView = 'Spaces View',
  Default = 'Default',
}
